import { selectBase } from './selectBase'

export const selectAnnualOffer = state => selectBase(state).annualOffer || null

export default selectAnnualOffer
